<div>
    Gold: {{store.gold}}
</div>
<div class="d-flex flex-wrap">
    <div *ngFor="let item of store.items" class="card m-2" style="width: 18rem;">
        <div class="card-body">
            <h5 class="card-title">{{item.name}}</h5>

            <div>Price: {{item.price * 15}}</div>

            <button class="btn btn-primary" (click)="Buy(item, item.price * 15)"
                [disabled]="store.gold < item.price * 15">Buy</button>
            <hr>
            <app-attribute-store [attributes]="item.effect_equip"></app-attribute-store>
        </div>


    </div>
</div>